import { create } from 'zustand'
import { DownloadRefusal } from '@/lib/download-protection/refusals'

/**
 * The refusal currently waiting on a dialog, if any.
 *
 * The download hook meets a refusal inside a callback and cannot render a dialog from
 * there, so it puts the refusal here and `<DownloadRefusalDialogs />` renders it.
 */
interface DownloadRefusalState {
  refusal: DownloadRefusal | null
  /**
   * How many refusals have been shown. A dialog that has to start over when the same code
   * arrives again — a Turnstile widget whose token was refused — keys itself on this, so a
   * repeat refusal remounts it with fresh state instead of leaving the spent one on screen.
   */
  sequence: number
  /** The retry the refused download handed over, if its path could provide one. */
  retry: ((challengeToken?: string) => void | Promise<void>) | null
  show: (refusal: DownloadRefusal, retry?: (challengeToken?: string) => void | Promise<void>) => void
  dismiss: () => void
}

export const useDownloadRefusalStore = create<DownloadRefusalState>()((set) => ({
  refusal: null,
  sequence: 0,
  retry: null,
  show: (refusal, retry) =>
    set((state) => ({ refusal, retry: retry ?? null, sequence: state.sequence + 1 })),
  dismiss: () => set({ refusal: null, retry: null }),
}))
